var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgIconrefresh = function SvgIconrefresh(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "19px",
    viewBox: "0 0 20 19",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icons/icon.refresh") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons/icon.refresh",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5,9.5 C17.5,5.35786438 14.1421356,2 10,2 C8.28411008,2 6.70280511,2.57622669 5.43903628,3.54572888 M2.5,9.5 C2.5,13.6421356 5.85786438,17 10,17 C11.7008692,17 13.2694994,16.4338176 14.5277021,15.4796414",
    id: "Shape",
    stroke: "#09BE86",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.71199958,5.83919932 L4.76093767,9.11750026 C4.83411525,9.2345844 4.79852196,9.38882199 4.68143782,9.46199958 C4.64170492,9.48683264 4.59579302,9.5 4.54893809,9.5 L0.45106191,9.5 C0.312990723,9.5 0.20106191,9.38807119 0.20106191,9.25 C0.20106191,9.20314507 0.214229272,9.15723317 0.239062334,9.11750026 L2.28800042,5.83919932 C2.36117801,5.72211519 2.5154156,5.6865219 2.63249974,5.75969948 C2.66469202,5.77981966 2.6918794,5.80700704 2.71199958,5.83919932 Z",
    id: "Triangle",
    fill: "#09BE86"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7119996,9.83919932 L19.7609377,13.1175003 C19.8341152,13.2345844 19.798522,13.388822 19.6814378,13.4619996 C19.6417049,13.4868326 19.595793,13.5 19.5489381,13.5 L15.4510619,13.5 C15.3129907,13.5 15.2010619,13.3880712 15.2010619,13.25 C15.2010619,13.2031451 15.2142293,13.1572332 15.2390623,13.1175003 L17.2880004,9.83919932 C17.361178,9.72211519 17.5154156,9.6865219 17.6324997,9.75969948 C17.664692,9.77981966 17.6918794,9.80700704 17.7119996,9.83919932 Z",
    id: "Triangle-Copy",
    fill: "#09BE86",
    transform: "translate(17.500000, 11.500000) scale(1, -1) translate(-17.500000, -11.500000) "
  }))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgIconrefresh);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon.refresh.768907f114e26c076b53e22fe2af59bb.svg";